import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BaseModule } from '@base/base.module';
import { ModalIframeComponent } from '@base/components/modal-iframe/modal-iframe.component';
import { ViewService } from '@base/services/view.service';
import { TrilogyComponentsModule } from '@base/trilogy.module';

import { CustomDistancePipe } from '@app/baseBtl/base/pipes/distance.pipe';
import { CustomPhoneSpacePipe } from '@app/baseBtl/base/pipes/phoneSpace.pipe';
import { MobileRecoveryModule } from '@app/modules/mobile-recovery/mobile-recovery.module';
import { RecoveryCartSummaryComponent } from '@app/modules/mobile-recovery/recovery-cart-summary/recovery-cart-summary.component';
import { FundingConfiguratorComponent } from '@app/modules/product-details/funding-configurator/funding-configurator.component';

import { StickyModule } from '@trilogy';

import { ProductAttributeComponent } from '../product-attribute/product-attribute.component';
import { ConfiguratorComponent } from './configurator/configurator.component';
import { PriceBlockHostDirective } from './directives/price-block-host.directive';
import { ViewTabsHostDirective } from './directives/view-tabs-host.directive';
import { AvailabilityAlertModalComponent } from './modals/availability-alert-modal/availability-alert-modal.component';
import { ConvergenceModalComponent } from './modals/convergence-modal/convergence-modal.component';
import { PortabilityModalComponent } from './modals/portability-modal/portability-modal.component';
import { ViewTabsModule } from './tabs/view-tabs.module';

@NgModule({
    imports: [
        CommonModule,
        BaseModule,
        ViewTabsModule,
        FormsModule,
        StickyModule,
        ReactiveFormsModule,
        TrilogyComponentsModule,
        MobileRecoveryModule,
        FundingConfiguratorComponent,
        ConfiguratorComponent,
    ],
    declarations: [
        ProductAttributeComponent,
        PriceBlockHostDirective,
        RecoveryCartSummaryComponent,
        ModalIframeComponent,
        AvailabilityAlertModalComponent,
        CustomDistancePipe,
        CustomPhoneSpacePipe,
        ViewTabsHostDirective,
        ConvergenceModalComponent,
        PortabilityModalComponent,
    ],
    exports: [
        ConfiguratorComponent,
        ProductAttributeComponent,
        PriceBlockHostDirective,
        RecoveryCartSummaryComponent,
        ModalIframeComponent,
        AvailabilityAlertModalComponent,
        TrilogyComponentsModule,
        ViewTabsModule,
        ConvergenceModalComponent,
        PortabilityModalComponent,
    ],
    providers: [ViewService],
})
export class ViewModule {}
